import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { assetUrl } from 'fusion-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'fusion-plugin-react-helmet-async';

export default function Login() {
    const [credentials, setCredentials] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const token = localStorage.getItem('token');

    useEffect(() => {
        const checkAuth = async () => {
            if (token) {

                navigate('/admin/dashboard');

            }
            setIsLoading(false);
        };

        checkAuth();
    }, [navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('/api/users/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(credentials),
            });

            const data = await response.json();

            if (response.ok) {
                localStorage.setItem('token', data.token);
                navigate('/admin/dashboard');
            } else {
                setError(data.message || 'Login failed');
            }
        } catch (err) {
            setError('An error occurred during login');
        }
    };



    return (
        <>
            <Helmet>
                <link rel="stylesheet" href={assetUrl('./styles/Login.css')} />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
                />
                <style>
                    {`
                    @font-face {
                        font-family: 'UberMoveTextRegular';
                        src: url(${assetUrl("../../assets/font/UberMoveTextRegular.otf")}) format('opentype');
                        font-weight: normal;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: 'UberMoveBold';
                        src: url(${assetUrl("../../assets/font/UberMoveBold.otf")}) format('opentype');
                        font-weight: bold;
                        font-style: normal;
                    }

                    @font-face {
                        font-family: "UberMoveTextMedium";
                        src: url(${assetUrl("../../assets/font/UberMoveMedium.otf")}) format("opentype");
                        font-weight: 500;
                        font-style: normal;
                    }

                    body {
                        font-family: 'UberMoveTextRegular', sans-serif;
                        margin: 0;
                        padding: 0;
                    }
                    
                    button {
                        font-family: 'UberMoveTextRegular', sans-serif;
                    }

                    h1, h2, h3, h4 {
                        font-family: 'UberMoveBold', sans-serif;
                    }
                    `}
                </style>
            </Helmet>
            <div className="login-page">
                <div className="login-container">
                    {token && (
                        <div className="loading">Loading...</div>
                    )}
                    {!token && <form onSubmit={handleSubmit} className="login-form">
                        <h2>Admin Login</h2>
                        {error && (
                            <div className="message-box error">
                                <span>
                                    <FontAwesomeIcon icon={faExclamationCircle} />
                                    {error}
                                </span>
                            </div>
                        )}
                        <div className="form-group">
                            <label htmlFor="email">
                                <FontAwesomeIcon icon={faEnvelope} /> Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                value={credentials.email}
                                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                                required
                                placeholder="Enter your email"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="password">
                                <FontAwesomeIcon icon={faLock} /> Password
                            </label>
                            <input
                                type="password"
                                id="password"
                                value={credentials.password}
                                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                                required
                                placeholder="Enter your password"
                            />
                        </div>
                        <button type="submit" className="login-btn">Login</button>
                    </form>}
                </div>
            </div>
        </>
    );
} 